// ARQUIVO ATUALIZADO
import React, { useState } from 'react';
import { createUserWithEmailAndPassword, signInWithEmailAndPassword } from 'firebase/auth';
import { getFirestore, doc, setDoc } from 'firebase/firestore';
import GlassCard from '../components/ui/Card';
import InputField from '../components/ui/Input';
import GlassButton from '../components/ui/Button';
import vflowLogo from '../assets/vflow-logo.png';
import { auth } from '../services/firebase';
// --- INÍCIO DA ALTERAÇÃO: Importando os avatares locais ---
import { avatars } from '../utils/avatars';
// --- FIM DA ALTERAÇÃO ---

const AuthPage = () => {
    const [isLogin, setIsLogin] = useState(true);
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [username, setUsername] = useState('');
    const [error, setError] = useState('');
    const [loading, setLoading] = useState(false);

    const getFriendlyErrorMessage = (err) => {
        switch (err.code) {
            case 'auth/email-already-in-use': return 'Este endereço de e-mail já está sendo usado por outra conta.';
            case 'auth/invalid-email': return 'O endereço de e-mail fornecido não é válido.';
            case 'auth/wrong-password': return 'Senha incorreta. Por favor, tente novamente.';
            case 'auth/user-not-found': return 'Nenhum usuário encontrado com este e-mail. Verifique o e-mail ou cadastre-se.';
            case 'auth/weak-password': return 'A senha deve ter pelo menos 6 caracteres.';
            default: return 'Ocorreu um erro inesperado. Por favor, tente novamente.';
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError('');
        setLoading(true);
        try {
            if (isLogin) {
                await signInWithEmailAndPassword(auth, email, password);
            } else {
                const userCredential = await createUserWithEmailAndPassword(auth, email, password);
                const user = userCredential.user;
                const db = getFirestore();

                // --- INÍCIO DA ALTERAÇÃO: Atribuindo o primeiro avatar da lista local ---
                // Verifica se há avatares na lista, caso contrário, usa uma string vazia
                const initialAvatarUrl = avatars.length > 0 ? avatars[0] : '';

                await setDoc(doc(db, "users", user.uid), {
                   username: username,
                   email: email,
                   avatarUrl: initialAvatarUrl, // Define o avatar inicial (o primeiro da lista)
                   hasSeenWelcomeModal: false,
                   quoteCounter: 0
                });
                // --- FIM DA ALTERAÇÃO ---
            }
        } catch (err) {
            setError(getFriendlyErrorMessage(err));
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="min-h-screen flex items-center justify-center bg-gray-900">
            <div className="absolute inset-0 z-0 overflow-hidden">
                <div className="absolute top-[-10%] left-[-10%] w-96 h-96 bg-purple-500 rounded-full filter blur-[100px] opacity-20 animate-blob1"></div>
                <div className="absolute top-[20%] right-[-10%] w-96 h-96 bg-pink-500 rounded-full filter blur-[100px] opacity-20 animate-blob2"></div>
                <div className="absolute bottom-[-10%] left-[20%] w-96 h-96 bg-sky-500 rounded-full filter blur-[100px] opacity-20 animate-blob3"></div>
            </div>
            <GlassCard className="w-full max-w-md z-10">
                <div className="flex justify-center mb-6">
                    <img src={vflowLogo} alt="V-Flow Logo" className="h-12" />
                </div>
                <h2 className="text-3xl font-bold text-center text-white mb-2">
                    {isLogin ? 'Bem-vindo de volta!' : 'Transforme o seu Fluxo!'}
                </h2>
                <p className="text-center text-gray-300 mb-6">{isLogin ? 'Pronto para criar?' : 'Cadastre-se e decole sua produtividade.'}</p>
                <form onSubmit={handleSubmit} className="space-y-6">
                    {!isLogin && ( <InputField label="Nome de Usuário" name="username" type="text" value={username} onChange={(e) => setUsername(e.target.value)} placeholder="Seu Nome" required /> )}
                    <InputField label="Email" name="email" type="email" value={email} onChange={(e) => setEmail(e.target.value)} placeholder="seu@email.com" required />
                    <InputField label="Senha" name="password" type="password" value={password} onChange={(e) => setPassword(e.target.value)} placeholder="********" required />
                    {error && <p className="text-red-400 text-sm text-center">{error}</p>}
                    <GlassButton type="submit" disabled={loading} className="w-full !bg-indigo-500 hover:!bg-indigo-600">
                        {loading ? 'Aguarde...' : (isLogin ? 'Entrar' : 'Cadastrar')}
                    </GlassButton>
                </form>
                <p className="text-center text-gray-400 text-sm mt-6">
                    {isLogin ? 'Não tem uma conta?' : 'Já tem uma conta?'}
                    <button onClick={() => setIsLogin(!isLogin)} className="font-semibold text-indigo-400 hover:underline ml-1">
                        {isLogin ? 'Cadastre-se' : 'Faça login'}
                    </button>
                </p>
            </GlassCard>
        </div>
    );
};

export default AuthPage;